<div class="right-side p-5">
  <div class="section">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="container mt-4">
      <div *ngFor="let section of responseData; let i = index" class="mb-4" [hidden]="i !== currentSectionIndex">
        <div class="row">
          <div class="card-title">
            <h1>
              {{ section.sectionTitle }}
            </h1>
          </div>
          <div [formGroupName]="section.sectionTitle">
            <div *ngFor="let question of section.questions" class="mb-3">
              <ng-container [ngSwitch]="question.inputType">

                <!-- Radio Button -->
                <div *ngSwitchCase="'radio'">
                  <label class="form-label">
                    &#10148;   {{ question.questionText }}
                  </label>
                  <div class="form-check" *ngFor="let option of question.optionsList">
                    <input type="radio" [formControlName]="'question_' + question.questionId" [value]="option.value" class="form-check-input"
                           id="{{ 'radio_' + question.questionId + '_' + option.value }}" />
                    <label for="{{ 'radio_' + question.questionId + '_' + option.value }}">
                      {{ option.label }}
                    </label>
                  </div>
                  <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')"
                       class="alert alert-danger">
                    This field is required.
                  </div>
                </div>

                <!-- Text Input -->
                <ng-container *ngIf="(question.questionText !== 'Other' &&
                              question.questionText !== 'Net Turnover  (Total Turnover-Export Turnover)')">
                  <div *ngSwitchCase="'text'">
                    <label class="form-label">
                      &#10148;   {{ question.questionText }}
                    </label>

                    <input type="text" [formControlName]="'question_' + question.questionId" class="form-control" />
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')" class="alert alert-danger">
                      This field is required.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'minlength')" class="alert alert-danger">
                      Minimum length is {{ question.minLength }}.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'maxlength')" class="alert alert-danger">
                      Maximum length is {{ question.maxLength }}.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'pattern')" class="alert alert-danger">
                      Please enter valid data.
                    </div>
                    <div *ngIf="question.questionId === 24 && getPanValidationMessage(section.sectionTitle)" class="alert alert-danger mt-1 py-1 px-2">
                      {{ getPanValidationMessage(section.sectionTitle) }}
                    </div>
                  </div>
                </ng-container>

                <!-- Net Turnover Question -->
                <ng-container *ngIf="(question.questionText === 'Net Turnover  (Total Turnover-Export Turnover)') ">
                  <div *ngSwitchCase="'text'">
                    <label class="form-label">
                      &#10148;   {{ question.questionText }}
                    </label>

                    <input type="text" [formControlName]="'question_' + question.questionId" class="form-control" value="" />
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')" class="alert alert-danger">
                      This field is required.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'minlength')" class="alert alert-danger">
                      Minimum length is {{ question.minLength }}.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'maxlength')" class="alert alert-danger">
                      Maximum length is {{ question.maxLength }}.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'pattern')" class="alert alert-danger">
                      Please enter valid data.
                    </div>
                  </div>
                </ng-container>

                <!-- Text Input -->
                <!--<ng-container *ngIf="(question.questionText !== 'Other' && question.questionText !== 'No.of Employees ( No. Male, No. Female, Total)') ">
    <div *ngSwitchCase="'text'">
      <label class="form-label">
        &#10148;   {{ question.questionText }}
      </label>
      <br />
      <label class="form-label">
        &#xb7;  No.of Male
      </label>
      <input type="text" [formControlName]="'question_' + question.questionId" class="form-control" />
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')" class="text-danger">
        This field is required.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'minlength')" class="text-danger">
        Minimum length is {{ question.minLength }}.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'maxlength')" class="text-danger">
        Maximum length is {{ question.maxLength }}.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'pattern')" class="text-danger">
        Please enter valid data.
      </div>

      <label class="form-label">
        &#xb7;   No.of Female
      </label>
      <input type="text" [formControlName]="'question_' + question.questionId" class="form-control" />
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')" class="text-danger">
        This field is required.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'minlength')" class="text-danger">
        Minimum length is {{ question.minLength }}.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'maxlength')" class="text-danger">
        Maximum length is {{ question.maxLength }}.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'pattern')" class="text-danger">
        Please enter valid data.
      </div>

      <label class="form-label">
        &#xb7; Others
      </label>
      <input type="text"
             [formControlName]="'question_' + question.questionId"
             class="form-control" />
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')" class="text-danger">
        This field is required.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'minlength')" class="text-danger">
        Minimum length is {{ question.minLength }}.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'maxlength')" class="text-danger">
        Maximum length is {{ question.maxLength }}.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'pattern')" class="text-danger">
        Please enter valid data.
      </div>

      <label class="form-label">
        &#xb7; Total
      </label>
      <input type="text"
             [formControlName]="'question_' + question.questionId"
             class="form-control" />
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')" class="text-danger">
        This field is required.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'minlength')" class="text-danger">
        Minimum length is {{ question.minLength }}.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'maxlength')" class="text-danger">
        Maximum length is {{ question.maxLength }}.
      </div>
      <div *ngIf="hasError(section.sectionTitle, question.questionId, 'pattern')" class="text-danger">
        Please enter valid data.
      </div>
    </div>
  </ng-container>-->
                <!-- Dropdown -->
                <div *ngSwitchCase="'dropdown'">
                  <label class="form-label">
                    &#10148;   {{ question.questionText }}
                  </label>
                  <select [formControlName]="'question_' + question.questionId" class="form-select">
                    <option *ngFor="let option of question.optionsList" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                  <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')"
                       class="alert alert-danger">
                    Please select an option.
                  </div>
                </div>

                <div *ngSwitchCase="'slider'">
                  <label class="form-label">
                    &#10148;   {{ question.questionText }}
                  </label>

                  <input type="range" [formControlName]="'question_' + question.questionId" [min]="question.min"
                         [max]="question.max" step="1" class="form-range" />

                  <span class="ms-2">
                    {{ form.get(section.sectionTitle)?.get('question_' + question.questionId)?.value || '0' }}
                  </span>

                  <!-- Validation Messages -->
                  <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')"
                       class="alert alert-danger">
                    This field is required.
                  </div>
                  <div *ngIf="hasError(section.sectionTitle, question.questionId, 'min')" class="alert alert-danger">
                    Value should be at least {{ question.min }}.
                  </div>
                  <div *ngIf="hasError(section.sectionTitle, question.questionId, 'max')" class="alert alert-danger">
                    Value should not exceed {{ question.max }}.
                  </div>
                </div>


                <div *ngSwitchCase="'label'">
                  <label class="form-label" style="color: red;">
                    <b>    Note : {{ question.questionText }}</b>
                  </label>
                </div>

                <div *ngSwitchCase="'labelInfo'">
                  <label class="form-label" >
                    <b>    {{ question.questionText }}</b>
                  </label>
                </div>

                <!-- Multi-select -->
                <div *ngSwitchCase="'multiselect'">
                  <label class="form-label">
                    &#10148;   {{ question.questionText }}
                  </label>

                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select multiple placeholder="Select Options"
                                [formControlName]="'question_' + question.questionId" [(ngModel)]="selectedObjects"
                                [compareWith]="comparer">
                      <mat-option *ngFor="let el of question.optionsList" [value]="el">
                        {{ el.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- Display the text input field if 'Other' is selected -->
                  <div *ngIf="isOtherSelected()">
                    <label class="form-label">
                      &#10148;   Other
                    </label>
                    <mat-form-field appearance="fill" class="w-100">
                      <input matInput placeholder="Please specify" [value]="defaultOtherValue" (input)="onInputChange($event)" />
                    </mat-form-field>
                  </div>


                  <!-- Validation Messages -->
                  <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')" class="alert alert-danger mt-1">
                    At least one option must be selected.
                  </div>
                  <div *ngIf="hasError(section.sectionTitle, question.questionId, 'minlength')" class="alert alert-danger mt-1">
                    Select at least {{ question.minLength }} option(s).
                  </div>
                  <div *ngIf="hasError(section.sectionTitle, question.questionId, 'maxlength')" class="alert alert-danger mt-1">
                    You can select at most {{ question.maxLength }} option(s).
                  </div>


                </div>
              </ng-container>
            </div>
          </div>

          <!-- Navigation Buttons -->
          <div class="d-flex justify-content-between mt-4">
            <button type="button" class="btn btn-secondary" (click)="previousSection()"
                    [disabled]="currentSectionIndex === 0">
              Previous
            </button>

            <button *ngIf="currentSectionIndex < responseData.length - 1" type="button" class="btn btn-primary"
                    (click)="nextSection()">
              Next
            </button>
          </div>

          <!-- Submit Button -->
          <div class="text-center mt-4" *ngIf="currentSectionIndex === responseData.length - 1">
            <button type="submit" class="btn btn-success">
              Submit
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
